import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from "@angular/core";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators
} from "@angular/forms";
import { Router, RouterModule, ActivatedRoute } from "@angular/router";

import { AngularFireAuth } from "@angular/fire/auth";

import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";

import { CarouselConfig } from "ngx-bootstrap/carousel";

import { UsersService } from "../../Services/users.service";

enum errorType {
  "info",
  "success",
  "warning",
  "danger"
}

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
  providers: [
    {
      provide: CarouselConfig,
      useValue: { interval: 3000, noPause: false, showIndicators: false }
    }
  ]
})
export class ResetPasswordComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("password") passwordField: ElementRef;
  passwordFormControl = new FormControl("", [Validators.required]);
  confirmPasswordFormControl = new FormControl("", [Validators.required]);

  errorObject = {
    alertType: errorType.info,
    alertMsg: "",
    showAlert: false
  };

  authSub;

  userId;
  showAlert;
  isRegistering;
  constructor(
    public afAuth: AngularFireAuth,
    public db: AngularFireDatabase,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(
      params => {
        this.userId = params.u;
        if (!this.userId) {
          this.errorObject.alertType = errorType.danger;
          this.errorObject.alertMsg =
            "Something went wrong. Please check the email with reset password instructions, and follow the steps.";
          this.errorObject.showAlert = true;
        }
      },
      error => {
        this.errorObject.alertType = errorType.danger;
        this.errorObject.alertMsg =
          "Something went wrong. Please check the email with reset password instructions, and follow the steps.";
        this.errorObject.showAlert = true;
      }
    );
  }

  ngAfterViewInit() {
    this.passwordField.nativeElement.focus();

  }

  async resetPassword() {
    let password = this.passwordFormControl.value;
    let confirmPassword = this.confirmPasswordFormControl.value;
    if (password.trim() !== confirmPassword.trim()) {
      this.errorObject.alertType = errorType.warning;
      this.errorObject.alertMsg = "Passwords should match.";
      this.errorObject.showAlert = true;
      return;
    }

    if (password.trim().length <= 0 || confirmPassword.trim().length <= 0) {
      this.errorObject.alertType = errorType.warning;
      this.errorObject.alertMsg = "Passwords cannot be blank.";
      this.errorObject.showAlert = true;
      return;
    }
    
    this.usersService.resetPassword(this.userId, password).subscribe(
      response => {
        this.errorObject.alertType = errorType.success;
        this.errorObject.alertMsg = "Password is reset successfully.";
        this.errorObject.showAlert = true;
        this.router.navigate(['/reset-password-success']);
      },
      error => {
        this.errorObject.alertType = errorType.danger;
        this.errorObject.alertMsg =
          "Could not complete the operation. Please try again later or contact support.";
        this.errorObject.showAlert = true;
      }
    );
  }

  onAlertClosed(alert) {
    this.errorObject.showAlert = false;
  }

  ngOnDestroy() {
    this.authSub = null;
  }
}
